import PageHeader from '../components/PageHeader';
import secondHeader from '../assets/images/secondHeader.png';
import aoaaf from '../assets/images/partners/aoaaf.png';
import RealEstate from '../assets/images/partners/RealEstate.png';
import family from '../assets/images/partners/family.png';
import legal from '../assets/images/partners/legal.png';
import ministry from '../assets/images/partners/ministry.png';
import paperMoney from '../assets/images/partners/paperMoney.png';
import raghy from '../assets/images/partners/raghy.png';
import stc from '../assets/images/partners/stc.png';
import watany from '../assets/images/partners/watany.png';
import timeBG from '../assets/images/timeBG.png';
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';

const partners = [
    { image: RealEstate, alt: '' },
    { image: family, alt: '' },
    { image: raghy, alt: '' },
    { image: stc, alt: 'STC' },
    { image: paperMoney, alt: '' },
    { image: watany, alt: '' },
    { image: legal, alt: '' },
    { image: ministry, alt: 'وزارة التجارة' },
    { image: aoaaf, alt: '' },
];

const Partners = () => {
    return (
        <>
            <PageHeader image={secondHeader} title="الجهات المشاركة" />

            <AnimatedSection className="w-full bg-white bg-contain py-16 px-6 md:py-20" style={{ backgroundImage: `url(${timeBG})` }}>
                <div className="mx-auto max-w-7xl">
                    <AnimatedGroup className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-6" stagger={0.08}>
                        {partners.map((partner, index) => (
                            <AnimatedItem
                                key={index}
                                className={`flex w-full justify-center ${
                                    index % 2 === 0 ? 'md:justify-end' : 'md:justify-start'
                                }`}
                            >
                                <div className="flex h-[250px] w-full max-w-[500px] items-center justify-center rounded-[20px] bg-white px-6 shadow-[0px_0px_5.87px_0.85px_#00000040]">
                                    <div className='h-[60%] w-[80%]'>
                                        <img
                                            src={partner.image}
                                            alt={partner.alt}
                                            className=" w-full h-full object-contain"
                                        />
                                    </div>
                                </div>
                            </AnimatedItem>
                        ))}
                    </AnimatedGroup>
                </div>
            </AnimatedSection>
        </>
    );
};

export default Partners;
